import { render, staticRenderFns } from "./NewPostForm.vue?vue&type=template&id=47eee8a5&scoped=true"
import script from "./NewPostForm.vue?vue&type=script&lang=js"
export * from "./NewPostForm.vue?vue&type=script&lang=js"
import style0 from "./NewPostForm.vue?vue&type=style&index=0&id=47eee8a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eee8a5",
  null
  
)

export default component.exports